export default "__VITE_ASSET__BRYhC6ve__"